import { Pipe, PipeTransform } from '@angular/core';
import { Submission } from 'src/app/model/paper';

/**
 * Ordena a lista de submissões da aba "Submissões" do diálogo de sessão.
 *
 * Grupos, nesta ordem:
 *   1. as que já pertencem a ESTA sessão;
 *   2. as sem sessão (disponíveis), por id;
 *   3. as alocadas em OUTRA sessão, pelo título da sessão (alfabético) e,
 *      dentro de cada sessão, por id.
 *
 * O agrupamento usa a sessão GRAVADA na submissão, não a marcação do checkbox:
 * ordenar por "está marcada" faria as linhas saltarem sob o cursor a cada
 * clique. Como a lista abre com as desta sessão já marcadas, o efeito visual
 * inicial é o mesmo.
 *
 * Pipe PURO: só recalcula quando a lista, a sessão ou o mapa de títulos mudam
 * de referência — não a cada ciclo de detecção.
 */
@Pipe({ name: 'subsOrder' })
export class SessionSubsOrderPipe implements PipeTransform {
  transform(items: Submission[], currentSessionId: number, sessionTitles: Map<number, string>): Submission[] {
    if (!items) { return []; }

    const groupOf = (submission: Submission): number => {
      const sessionId = submission.session as unknown as number;
      if (!sessionId) { return 1; }
      return sessionId === currentSessionId ? 0 : 2;
    };

    const titleOf = (submission: Submission): string => {
      const sessionId = submission.session as unknown as number;
      return (sessionTitles && sessionTitles.get(sessionId)) || '';
    };

    // Cópia antes de ordenar: `sort` muta o array, e o de entrada é o do
    // componente (ou o resultado do filtro de texto).
    return [...items].sort((a, b) => {
      const groupDiff = groupOf(a) - groupOf(b);
      if (groupDiff !== 0) { return groupDiff; }

      if (groupOf(a) === 2) {
        const titleDiff = titleOf(a).localeCompare(titleOf(b));
        if (titleDiff !== 0) { return titleDiff; }
      }

      return a.id - b.id;
    });
  }
}
